import { MeasureConnectedProps, MeasureSchemaObject } from '@grow-therapy-team/seedling-components';

export type MeasureSchemaAndAnswers = {
  schema: MeasureConnectedProps['schema'] & Pick<MeasureSchemaObject, 'measureSchemaShortId'>;
  answers: Record<string, unknown>;
  errors: string[];
  hasSubmitted: boolean;
  provider?: MeasureConnectedProps['provider'];
};

export enum PendingMeasuresFormLayout {
  DRAWER = 'drawer',
  PAGE = 'page',
}
